exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".PmIvp {\n  padding: 10px 20px !important;\n}\n.PmIvp {\n  position: absolute;\n  right: 0;\n  -webkit-transition: opacity 0.3s;\n  -o-transition: opacity 0.3s;\n  transition: opacity 0.3s;\n  opacity: 0;\n  z-index: 0;\n  pointer-events: none;\n}\n.PmIvp ul {\n  padding-left: 0;\n}\n.PmIvp._2I5sj {\n  opacity: 1;\n  z-index: 2;\n  pointer-events: auto;\n}\n", ""]);

// Exports
exports.locals = {
	"dropdownMenu": "PmIvp",
	"active": "_2I5sj"
};